import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, message, Spin } from 'antd';
import { QrcodeOutlined, UserOutlined } from '@ant-design/icons';
import api from '../api/axios';

const SchoolLogin = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);
  const [thirdPartyLoading, setThirdPartyLoading] = useState(false);
  const [showThirdPartyHint, setShowThirdPartyHint] = useState(false);
  const [form] = Form.useForm();

  // 检查URL中是否有code参数，如果有则自动进行第三方登录
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    
    if (code) {
      handleThirdPartyLogin(code);
    }
  }, []);

  const handleLogin = async (values) => {
    setLoading(true);
    try {
      const response = await api.post('/school/login', values);
      localStorage.setItem('school_token', response.data.token);
      localStorage.setItem('school_teacher', JSON.stringify(response.data.teacher));
      message.success('登录成功');
      onLogin(response.data.teacher);
    } catch (error) {
      message.error(error.response?.data?.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  const handleThirdPartyLogin = async (code) => {
    setThirdPartyLoading(true);
    setShowThirdPartyHint(true);
    
    try {
      const response = await api.post('/school/loginbycode', { code });
      localStorage.setItem('school_token', response.data.token);
      localStorage.setItem('school_teacher', JSON.stringify(response.data.teacher));
      message.success('登录成功');
      onLogin(response.data.teacher);
    } catch (error) {
      message.error(error.response?.data?.message || '登录失败');
      setShowThirdPartyHint(false);
    } finally {
      setThirdPartyLoading(false);
    }
  };

  // 模拟获取第三方登录code（实际场景中应该是从第三方系统跳转回来时携带code）
  const handleGetThirdPartyCode = () => {
    // 模拟跳转到第三方登录页面，然后返回带code的URL
    // 实际场景中这里应该是跳转到第三方认证页面
    setShowThirdPartyHint(true);
    setThirdPartyLoading(true);
    
    // 模拟延迟后获取code并登录
    setTimeout(() => {
      // 模拟获取到code
      const mockCode = 'mock_code_' + Date.now();
      handleThirdPartyLogin(mockCode);
    }, 2000);
  };

  if (showThirdPartyHint && thirdPartyLoading) {
    return (
      <div className="login-container">
        <Card className="login-card" style={{ textAlign: 'center', padding: '40px' }}>
          <Spin size="large" />
          <p style={{ marginTop: 20, fontSize: 16 }}>正在登录...</p>
          <p style={{ color: '#8c8c8c', marginTop: 8 }}>请稍候，正在验证您的身份</p>
        </Card>
      </div>
    );
  }

  return (
    <div className="login-container">
      <Card className="login-card">
        <h2 style={{ textAlign: 'center', marginBottom: 24 }}>学校管理平台</h2>
        
        {/* 第三方登录按钮 */}
        <div style={{ marginBottom: 24 }}>
          <Button
            type="primary"
            size="large"
            icon={<QrcodeOutlined />}
            onClick={handleGetThirdPartyCode}
            loading={thirdPartyLoading}
            style={{ width: '100%', marginBottom: 12 }}
          >
            第三方登录
          </Button>
          <p style={{ textAlign: 'center', color: '#8c8c8c', fontSize: 12 }}>
            通过统一身份认证平台登录
          </p>
        </div>
        
        {/* 分割线 */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
          <div style={{ flex: 1, height: 1, background: '#e8e8e8' }}></div>
          <span style={{ padding: '0 12px', color: '#8c8c8c', fontSize: 12 }}>或</span>
          <div style={{ flex: 1, height: 1, background: '#e8e8e8' }}></div>
        </div>
        
        {/* 账号密码登录 */}
        <Form
          form={form}
          layout="vertical"
          onFinish={handleLogin}
        >
          <Form.Item
            name="username"
            label="用户名"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input placeholder="请输入用户名" prefix={<UserOutlined />} />
          </Form.Item>
          <Form.Item
            name="password"
            label="密码"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password placeholder="请输入密码" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%' }}>
              登录
            </Button>
          </Form.Item>
        </Form>
        <p style={{ textAlign: 'center', color: '#8c8c8c', marginTop: 16 }}>
          测试账号：teacher / 123456
        </p>
      </Card>
    </div>
  );
};

export default SchoolLogin;
